import { SeoRenderer } from "../../../common/helpers/seo";

import loadingComponent from "./loadable";


export default {
    component: loadingComponent,
    renderSeo: ({ dispatch }, allMessage, lang) => {
        SeoRenderer({ title: allMessage["menu.homeworks"], allMessage, lang });
    },
};
